<template>
  <b-button :to="route" :title="$i18n.t(title)" :class="bootstrapClass"
            @click="onClick" v-b-tooltip
  >
    <font-awesome v-if="faClass" :fa-class="faClass" :class="'float-' + faPosition" />

    <span v-if="text">{{ $t(text) }}</span>
  </b-button>
</template>

<script>
import bButton from 'bootstrap-vue/es/components/button/button'
import fontAwesome from '@/components/global/icon/fontAwesome'

export default {
  components: {
    bButton,
    fontAwesome
  },

  props: {
    route: [Object, String],
    text: String,
    title: String,
    faClass: String,
    faPosition: {
      type: String,
      default: 'none'
    },
    bootstrapClass: String,
    callback: Function
  },

  methods: {
    onClick () {
      if (this.callback) this.callback()
      this.$emit('click')
    }
  }
}
</script>
